export const REFERRAL_STATUSES = [
  {
    id: 'blank',
    value: null,
    label: 'Blank',
    selected: false,
  },
  {
    id: 'to-be-referred',
    value: 'to-be-referred',
    label: 'To be referred',
    selected: true,
  },
  {
    id: 'referred',
    value: 'referred',
    label: 'Referred',
    selected: false,
  },
];

export const DOCTOR_REFERRAL_STATUSES = [
  {
    id: 'blank',
    value: null,
    label: 'Blank',
    selected: false,
  },
  {
    id: 'to-be-referred',
    value: 'to-be-referred',
    label: 'To be referred',
    selected: true,
    default: true,
  },
  {
    id: 'referred',
    value: 'referred',
    label: 'Referred',
    selected: false,
  },
];

export const TYPES = [
  {
    id: 'cpap-initial',
    value: 'cpap-initial',
    label: 'CPAP: initial',
    selected: true,
  },
  {
    id: 'cpap-first-renewal',
    value: 'cpap-first-renewal',
    label: 'CPAP: first renewal',
    selected: true,
  },
  {
    id: 'cpap-annual-renewal',
    value: 'cpap-annual-renewal',
    label: 'CPAP: annual renewal',
    selected: true,
  },
  {
    id: 'orthesis',
    value: 'orthesis',
    label: 'Orthesis',
    selected: false,
  },
  {
    id: 'ceinture-anti-ronflement',
    value: 'ceinture-anti-ronflement',
    label: 'Ceinture anti ronflement',
    selected: false,
  },
  {
    id: 'other',
    value: 'other',
    label: 'Other',
    selected: false,
  },
];

export const PSAD_TYPES = [
  {
    id: 'cpap-initial',
    value: 'cpap-initial',
    label: 'CPAP: initial',
    selected: true,
  },
  {
    id: 'cpap-first-renewal',
    value: 'cpap-first-renewal',
    label: 'CPAP: first renewal',
    selected: true,
  },
  {
    id: 'cpap-annual-renewal',
    value: 'cpap-annual-renewal',
    label: 'CPAP: annual renewal',
    selected: true,
  },
];

export const EQUIPMENT_TYPES = [
  {
    id: 'equipped',
    value: 'equipped',
    label: 'Equipped',
  },
  {
    id: 'not-equipped',
    value: 'not equipped',
    label: 'Not Equipped',
  },
  {
    id: 'patient-refused',
    value: 'patient refused',
    label: 'Patient refused',
  },
  {
    id: 'patient-transferred',
    value: 'patient transferred',
    label: 'Patient transferred',
  },
];

export const DOCTOR_TREATMENT_TYPES = [
  {
    id: 'cpap-initial',
    value: 'cpap-initial',
    label: 'CPAP: initial',
    default: true,
  },
  {
    id: 'cpap-first-renewal',
    value: 'cpap-first-renewal',
    label: 'CPAP: first renewal',
  },
  {
    id: 'cpap-annual-renewal',
    value: 'cpap-annual-renewal',
    label: 'CPAP: annual renewal',
  },
  {
    id: 'orthesis',
    value: 'orthesis',
    label: 'Orthesis',
  },
  {
    id: 'ceinture-anti-ronflement',
    value: 'ceinture-anti-ronflement',
    label: 'Ceinture anti ronflement',
  },
];

export const COLUMNS = [
  {
    label: 'Customer',
    accessor: 'customer',
    type: 'customer',
    isFilterable: false,
    classNames: 'th-list-sticky th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Actions',
    accessor: 'treatments',
    type: 'actions',
    isFilterable: false,
    classNames: 'th-list-cellwidth-120',
    selected: true,
  },
  {
    label: 'Doctor',
    accessor: 'doctor',
    type: 'doctor',
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: true,
    options: [
      {
        id: 'blank',
        value: null, //for blank records
        label: 'Blank',
        selected: true,
      },
    ],
  },
  {
    label: 'Type',
    accessor: 'type',
    type: 'select',
    options: TYPES,
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Referral status',
    accessor: 'referralStatus',
    type: 'select',
    options: REFERRAL_STATUSES,
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Referral date',
    accessor: 'referredAt',
    type: 'singleDatePicker',
    isFilterable: false,
    isSortable: true,
    sortLabel: 'Referral date: Later first, blank before',
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Treating organization',
    accessor: 'treatingOrg',
    type: 'treatingOrg',
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: true,
    options: [
      {
        id: 'blank',
        value: null, //for blank records
        label: 'Blank',
        selected: true,
      },
    ],
  },
];

export const DOCTOR_COLUMNS = [
  {
    label: 'Customer',
    accessor: 'customer',
    type: 'customer',
    isFilterable: false,
    selected: true,
  },
  {
    label: 'Actions',
    accessor: 'treatments',
    type: 'actions',
    isFilterable: false,
    classNames: 'th-list-cellwidth-120',
    selected: true,
  },
  {
    label: 'Type',
    accessor: 'type',
    type: 'select',
    options: TYPES,
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: true,
    readOnly: true,
  },
  {
    label: 'Referral date',
    accessor: 'referredAt',
    type: 'singleDatePicker',
    isFilterable: false,
    isSortable: true,
    sortLabel: 'Referral date: Later first, blank before',
    classNames: 'th-list-cellwidth-240',
    selected: true,
    readOnly: true,
  },
  {
    label: 'Treating organization',
    accessor: 'treatingOrg',
    type: 'treatingOrg',
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: true,
    options: [
      {
        id: 'blank',
        value: null, //for blank records
        label: 'Blank',
        selected: true,
      },
    ],
  },
];

export const DOCTOR_INCOMPLETE_COLUMNS = [
  {
    label: 'Customer',
    accessor: 'customer',
    type: 'customer',
    isFilterable: false,
    classNames: 'th-list-sticky th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Actions',
    accessor: 'treatments',
    type: 'actions',
    isFilterable: false,
    classNames: 'th-list-cellwidth-120',
    selected: true,
  },
  {
    label: 'Type',
    accessor: 'type',
    type: 'select',
    options: TYPES,
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
    selected: true,
    readOnly: true,
  },
  {
    label: 'Referral date',
    accessor: 'referredAt',
    type: 'singleDatePicker',
    isFilterable: false,
    isSortable: true,
    sortLabel: 'Referral date: Later first, blank before',
    classNames: 'th-list-cellwidth-240',
    selected: true,
    readOnly: true,
  },
  {
    label: 'Treating organization',
    accessor: 'treatingOrg',
    type: 'treatingOrg',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
    selected: true,
    options: [
      {
        id: 'blank',
        value: null, //for blank records
        label: 'Blank',
        selected: true,
      },
    ],
  },
];

export const PSAD_COLUMNS = [
  {
    label: 'Equipment Status',
    accessor: 'equipmentStatus',
    type: 'equipmentStatus',
    isFilterable: true,
    classNames: 'th-list-sticky th-list-cellwidth-exact-240 pointer',
    selected: true,
    options: [
      {
        id: 'equipped',
        value: 'equipped',
        label: 'Equipped',
        selected: true,
      },
      {
        id: 'not-equipped',
        value: 'not equipped',
        label: 'Not Equipped',
        selected: true,
      },
      {
        id: 'patient-refused',
        value: 'patient refused',
        label: 'Patient refused',
        selected: true,
      },
      {
        id: 'patient-transferred',
        value: 'patient transferred',
        label: 'Patient transferred',
        selected: true,
      },
    ],
  },
  {
    label: 'Customer',
    accessor: 'customer',
    type: 'customer',
    isFilterable: false,
    classNames: ' th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Doctor',
    accessor: 'doctor',
    type: 'doctor',
    isFilterable: true,
    readOnly: true,
    classNames: 'th-list-cellwidth-240',
    selected: true,
    options: [
      {
        id: 'blank',
        value: null, //for blank records
        label: 'Blank',
        selected: true,
      },
    ],
  },
  {
    label: 'Type',
    accessor: 'type',
    type: 'select',
    options: PSAD_TYPES,
    readOnly: true,
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Referral date',
    accessor: 'referredAt',
    type: 'singleDatePicker',
    isFilterable: false,
    isSortable: true,
    sortLabel: 'Referral date: Later first, blank before',
    classNames: 'th-list-cellwidth-240',
    selected: true,
    readOnly: true,
  },
];

export const EQUIPMENT_BADGE_TYPES = [
  'cpap-initial',
  'cpap-first-renewal',
  'cpap-annual-renewal',
];
